(function ($) {
    "use strict";
    
    $.fn.extend({
        ncip: function (serviceUrl, callback) {

            return this.each(function () {
            	var $elem = $(this);
                var id = $elem.data("id");
                $.ajax({
                    type: "POST",
                    async: true,
                    cache: false,
                    url: serviceUrl,
                    data: "action=lookup&itemId=" + id,
                    dataType: "json",
                    success: function (data) {
                        callback($elem, data);
                    }
                });
            });
        }
    });
})(jQuery);